export default "__VITE_ASSET__32fbea64__"